module.exports = __webpack_public_path__ + "img/aboutUs@2x.5ebda0c.jpg";